<template>
  <!-- /*讲故事*/-->
  <div class="resistance">
    <div class="contentnr">
      <div class="top">
        <div>
          <slot name="plate"></slot>
        </div>
      </div>
      <div class="content">
        <div class="resistance-character clearfix">
          <div class="button-prev"></div>
          <swiper :options="swiperOption" ref="mySwiper">
            <swiper-slide v-for="(item,index) in screentowdata" class="enlarge" :key="index">
              <img :src="item.basicThumbnail" @click="handleTab(index)">
               <div class="swiper-slide-title ">
                 <div class="text-tow-overflow"  v-html="item.basicTitle"> {item.basicTitle}}</div>
               </div>
            </swiper-slide>
          </swiper>
          <div class="button-next"></div>
        </div>
        <div class="resistance-content clearfix">
          <div class="resistance-content-left">
            <img :src=img alt="">
          </div>
          <div class="resistance-content-right">
            <h3 class="nowrap product-buyer-name"  v-html="title"   :title="title">{{title}}</h3>
            <p v-html="content">
              {{content}}
            </p>
            <span @click="handleHerf()">阅读全文</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import util from '@/assets/js/util'
  /*总书记讲历史*/
  import {getjlsdata} from '@/api/generalsecretary.js'
  export default {
    name: "resistance",
    data() {
      return {
        screentowdata: [],
        isdetails: true,
        swiperOption: {
          notNextTick: true,
          initialSlide: 0,
          direction: 'horizontal',
          autoplay: {
            delay: 1000,
            stopOnLastSlide: false,
            disableOnInteraction: true
          },
          navigation: {
            nextEl: '.button-next',
            prevEl: '.button-prev',
          },
          loopedSlides: 4,
          loopAdditionalSlides: 0,
          slidesPerView: 4,
          observer: true,
          observeParents: true
        },
        title: '',
        content: '',
        img: '',
        id: ''
      }
    },
    mounted() {
      /*初始化取json数据*/
      if (util.isEmpty(this.screentowdata)) {
        getjlsdata().then(res => {
          if (res.length > 0) {
            if (!util.isEmpty(res) && this.screentowdata) {
              this.screentowdata = res;
              this.title = this.screentowdata[0].basicTitle;
              this.content = this.screentowdata[0].basicRoundup;
              this.img = this.screentowdata[0].basicThumbnail;
              this.id = this.screentowdata[0].basicId
            } else {
              console.log('没有数据')
            }
          }
        }).catch((err) => {
          console.log(err, "4")
        })
      }
    },
    methods: {
      handleTab(index) {
        if (this.screentowdata.length > 0) {
          this.title = this.screentowdata[index].basicTitle;
          this.content = this.screentowdata[index].basicRoundup;
          this.img = this.screentowdata[index].basicThumbnail;
          this.id = this.screentowdata[index].basicId
        }
      },
      handleHerf() {
       let two = this.$router.resolve({
          path: `/Details/${this.id}&&1`,
        })
        window.open(two.href, '_blank');
      }
    },
  }
</script>

<style scoped>
  .resistance-content-right {
    position: relative;
    float: left;
    text-align: left;
    width: 719px;
    height: 100%;
  }

  .resistance-content-right h3 {
    height: 36px;
    font-weight: 900;
    font-size: 30px;
    color: #aa0000;
    margin-bottom: 26px;
  }

  .resistance-content-right p {
    width: 719px;
    height: 251px;
    font-family: FZLTXHK--GBK1-0;
    font-size: 20px;
    line-height: 36px;
    color: #000000;
    overflow: hidden;
  }

  .resistance-content-right span {
    position: absolute;
    right: 0;
    /*bottom: -24px;*/
    bottom: 0px;
    display: block;
    width: 107px;
    height: 33px;
    background-color: #6f4326;
    border-radius: 8px;
    color: #ffffff;
    line-height: 33px;
    font-size: 20px;
    text-align: center;
    cursor: pointer;
  }

  .resistance-content-right span:hover {
    color: #40A9FF;
  }

  .resistance-content-left {
    float: left;
    margin-right: 52px;
    width: 511px;
    height: 315px;
  }

  .resistance-content-left > img {
    width: 100%;
    height: 100%;
  }

  .swiper-slide .swiper-slide-duplicate {
    width: 170px;
    height: 221px;
  }

  .resistance {
    height: 100%;
    text-align: center;
  }

  .content {
    width: 100%;
    height: 100%;
  }

  .resistance-character {
    display: inline-block;
    text-align: center;
    position: relative;
    margin-top: 22px;
    margin-bottom: 65px;
    width: 1382px;
    height: 180px;
  }

  .button-prev, .button-next {
    position: absolute;
    top: 0;
    width: 58.5px;
    height:195.06px !important;
    cursor: pointer;
  }

  .button-prev {
    z-index: 10000;
    left: 0;
    background: url("../../../assets/img/left-icon.png");
    background-size: 100% 100%;
    background-repeat: no-repeat;
  }

  .button-next {
    z-index: 10000;
    right: 0;
    background: url("../../../assets/img/right-icon.png");
    background-size: 100% 100%;
    background-repeat: no-repeat;
  }

  .resistance-content {
    position: relative;
    width: 1382px;
    height: 351px;
    display: inline-block;
  }

  .contentnr {
    width: 100%;
    float: left;
  }

  .top {
    position: relative;
    width: 100%;
    height: 226px;
  }

  .top > div {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 1382px;
    height: 193px;
    background: url("../../../assets/img/tophongqi.png") no-repeat;
    background-size: 100% 100%;
    border-radius: 6px;
  }
  .enlarge.swiper-slide{
    width: 316px !important;
    height:195.06px !important;
    cursor: pointer;
  }
  .enlarge.swiper-slide img{
    width: 316px !important;
    height:195.06px !important;
    margin: 0 auto;
  }
  .swiper-container{
    margin: 0px !important;
    margin-left: 60px!important;
  }

  /*.swiper-slide {
    width: 292px !important;
    height: 180px;
    cursor: pointer;
    position: relative;
  }*/
  .swiper-slide-title{
    padding-left: 10px;
    display: flex;
    align-items: center;
    height: 50px;
    box-sizing: border-box;
    text-align: left;
    width: 316px;
    position: absolute;
    bottom: 0;
    left: 0px;
    background-color: rgba(0,0,0,0.4);
    color: white;
    margin: 0 auto;
  }
  .swiper-slide-title>p{
    font-size: 16px !important;
    line-height: 20px;
    width: 100%;
    height: 100%;
    padding: 10px 20px!important;
    box-sizing: border-box;
    text-align: left;
    position: absolute;
    bottom: 0;
    left: 0px;
    background-color: rgba(0,0,0,0.4);
    color: white;
  }



  .swiper-slide > img {
    width: 292px;
    height: 180px;
  }
  .swiper-container {
    width: 1263px !important;
  }


</style>



// WEBPACK FOOTER //
// src/pages/Home/components/resistance.vue